export const validateEmail = (email) => /.+@.+\.[A-Za-z]+$/.test(email);